var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPepiconsPencilCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 68,
    viewBox: "0 0 74 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 52,
    rx: 34.5,
    ry: 11.5,
    fill: "#D5EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_265)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 40.5,
    width: 44,
    height: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5714 53.3572V53.8572H16.0714H58.9286H59.4286V53.3572V17.6429V17.1429H58.9286H16.0714H15.5714V17.6429V53.3572ZM14.2857 14.5715H60.7143C61.0553 14.5715 61.3823 14.7069 61.6234 14.948C61.8645 15.1892 62 15.5162 62 15.8572V55.1429C62 55.4839 61.8645 55.8109 61.6234 56.052C61.3823 56.2932 61.0553 56.4286 60.7143 56.4286H14.2857C13.9447 56.4286 13.6177 56.2932 13.3766 56.052C13.1355 55.8109 13 55.4839 13 55.1429V15.8572C13 15.5162 13.1355 15.1892 13.3766 14.948C13.6177 14.7069 13.9447 14.5715 14.2857 14.5715Z",
    fill: "#0593F5",
    stroke: "#D5EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5714 24.7858V25.2858H16.0714H58.9286H59.4286V24.7858V17.6429V17.1429H58.9286H16.0714H15.5714V17.6429V24.7858ZM14.2857 14.5715H60.7143C61.0553 14.5715 61.3823 14.7069 61.6234 14.948C61.8645 15.1892 62 15.5162 62 15.8572V26.5715C62 26.9125 61.8645 27.2395 61.6234 27.4806C61.3823 27.7217 61.0553 27.8572 60.7143 27.8572H14.2857C13.9447 27.8572 13.6177 27.7217 13.3766 27.4806C13.1355 27.2395 13 26.9125 13 26.5715V15.8572C13 15.5162 13.1355 15.1892 13.3766 14.948C13.6177 14.7069 13.9447 14.5715 14.2857 14.5715Z",
    fill: "#0593F5",
    stroke: "#D5EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9108 11.3766L26.2571 11.0302L25.9108 11.3766C26.1519 11.6177 26.2874 11.9447 26.2874 12.2857V15.8571C26.2874 16.1981 26.1519 16.5252 25.9108 16.7663C25.6697 17.0074 25.3427 17.1429 25.0017 17.1429H21.4302C21.0893 17.1429 20.7622 17.0074 20.5211 16.7663L20.1712 17.1162L20.5211 16.7663C20.28 16.5252 20.1445 16.1981 20.1445 15.8571V12.2857C20.1445 11.9447 20.28 11.6177 20.5211 11.3766C20.7622 11.1355 21.0893 11 21.4302 11H25.0017C25.3427 11 25.6697 11.1355 25.9108 11.3766ZM53.5731 17.1429H50.0017C49.6607 17.1429 49.3337 17.0074 49.0925 16.7663C48.8514 16.5252 48.716 16.1981 48.716 15.8571V12.2857C48.716 11.9447 48.8514 11.6177 49.0925 11.3766C49.3337 11.1355 49.6607 11 50.0017 11H53.5731C53.9141 11 54.2411 11.1355 54.4822 11.3766C54.7234 11.6177 54.8588 11.9447 54.8588 12.2857V15.8571C54.8588 16.1981 54.7234 16.5252 54.4822 16.7663C54.2411 17.0074 53.9141 17.1429 53.5731 17.1429ZM23.216 38.5714C22.4014 38.5714 21.6201 38.2478 21.0441 37.6718C20.4681 37.0958 20.1445 36.3146 20.1445 35.5C20.1445 34.6854 20.4681 33.9042 21.0441 33.3282C21.6201 32.7522 22.4014 32.4286 23.216 32.4286C24.0306 32.4286 24.8118 32.7522 25.3878 33.3282C25.9638 33.9042 26.2874 34.6854 26.2874 35.5C26.2874 36.3146 25.9638 37.0958 25.3878 37.6718C24.8118 38.2478 24.0306 38.5714 23.216 38.5714Z",
    fill: "#0593F5",
    stroke: "#D5EEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(12.5 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepiconsPencilCalendar);
export default __webpack_public_path__ + "static/media/pepicons-pencil_calendar.c8e4b7f6769b4202173c6ab49367bd2c.svg";
export { ForwardRef as ReactComponent };